module.exports = __webpack_public_path__ + "img/img13.5a0fe90e.png";